import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "src/app/services/app-config.service";

@Injectable({
    providedIn: 'root'
})
export class DataConsoleService {
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    apiUrl = AppConfig.settings.apiUrl;

    constructor(private http: HttpClient) { }

    getGridData(){
        return this.http.get(`${this.apiUrl}/DataConsole/GetDataConsoleRecords`, this.httpOptions);
    }
}